(function () {
  if (window.__signageBrandingFormTriggerInit) return;
  window.__signageBrandingFormTriggerInit = true;

  var HIDDEN_CLASS = 'signage-bento-form-target-hidden';
  var CLOSE_CLASS = 'signage-bento-form-close-btn';
  var PAGE_MARKER_SELECTOR = '[data-signage-branding-form-page="true"]';
  var TRIGGER_SELECTOR = '[data-form-target]';
  var targetStates = new WeakMap();

  function hasPageMarker() {
    return !!document.querySelector(PAGE_MARKER_SELECTOR);
  }

  function resolveTarget(raw) {
    if (!raw) return null;

    var value = String(raw).trim();
    if (!value) return null;

    var looksLikeSelector =
      value.indexOf('#') === 0 ||
      value.indexOf('.') === 0 ||
      value.indexOf('[') === 0 ||
      value.indexOf('shopify-section-') === 0;

    if (looksLikeSelector) {
      try {
        var selector = value.indexOf('shopify-section-') === 0 ? '#' + value : value;
        var bySelector = document.querySelector(selector);
        if (bySelector) return bySelector;
      } catch (error) {}
    }

    var byId = document.getElementById('shopify-section-' + value);
    if (byId) return byId;

    try {
      var byQuery = document.querySelector(value);
      if (byQuery) return byQuery;
    } catch (error) {}

    return document.querySelector('[id^="shopify-section-"][id$="__' + CSS.escape(value) + '"]');
  }

  function getFormInner(targetEl) {
    return targetEl.querySelector('[data-form-id]');
  }

  function ensureTargetState(targetEl) {
    var existing = targetStates.get(targetEl);
    if (existing) return existing;

    var state = {
      revealed: false,
      observer: null,
      formInner: getFormInner(targetEl),
    };

    targetStates.set(targetEl, state);
    return state;
  }

  function hideTarget(targetEl, state) {
    if (state.revealed) return;
    targetEl.classList.add(HIDDEN_CLASS);
    targetEl.setAttribute('aria-hidden', 'true');
  }

  function attachObserver(targetEl, state) {
    if (state.observer) state.observer.disconnect();
    state.observer = new MutationObserver(function () {
      if (state.revealed) return;
      if (!targetEl.classList.contains(HIDDEN_CLASS)) hideTarget(targetEl, state);
    });
    state.observer.observe(targetEl, { attributes: true, attributeFilter: ['class', 'style'] });
  }

  function ensureCloseButton(targetEl) {
    if (targetEl.querySelector('.' + CLOSE_CLASS)) return;

    var style = window.getComputedStyle(targetEl);
    if (style.position === 'static') {
      targetEl.style.position = 'relative';
    }

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = CLOSE_CLASS;
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML = '\u00d7';
    closeBtn.setAttribute('data-form-close', 'true');
    targetEl.appendChild(closeBtn);
  }

  function setupTarget(targetEl) {
    var state = ensureTargetState(targetEl);
    hideTarget(targetEl, state);
    attachObserver(targetEl, state);
    ensureCloseButton(targetEl);
  }

  function revealTarget(targetEl) {
    var state = ensureTargetState(targetEl);
    state.revealed = true;
    if (state.observer) state.observer.disconnect();
    targetEl.classList.remove(HIDDEN_CLASS);
    targetEl.removeAttribute('aria-hidden');

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var rect = targetEl.getBoundingClientRect();
        var top = rect.top + window.scrollY;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  function closeTarget(targetEl) {
    var state = ensureTargetState(targetEl);
    state.revealed = false;
    hideTarget(targetEl, state);
    attachObserver(targetEl, state);
  }

  function getOpenedTargets() {
    var opened = [];
    document.querySelectorAll('[id^="shopify-section-"]').forEach(function (el) {
      var state = targetStates.get(el);
      if (!state) return;
      if (!state.revealed) return;
      if (el.classList.contains(HIDDEN_CLASS)) return;
      opened.push(el);
    });
    return opened;
  }

  function onDocumentClick(event) {
    var closeButton = event.target.closest('[data-form-close="true"]');
    if (closeButton) {
      var closeTargetEl = closeButton.closest('[id^="shopify-section-"]');
      if (closeTargetEl) {
        event.preventDefault();
        event.stopPropagation();
        closeTarget(closeTargetEl);
      }
      return;
    }

    var triggerEl = event.target.closest(TRIGGER_SELECTOR);
    if (triggerEl) {
      var targetRaw = (triggerEl.getAttribute('data-form-target') || '').trim();
      if (!targetRaw) return;
      var targetEl = resolveTarget(targetRaw);
      if (!targetEl) return;

      event.preventDefault();
      setupTarget(targetEl);
      revealTarget(targetEl);
      return;
    }

    getOpenedTargets().forEach(function (targetEl) {
      var state = ensureTargetState(targetEl);
      var formInner = state.formInner || getFormInner(targetEl);
      if (formInner ? formInner.contains(event.target) : targetEl.contains(event.target)) return;
      closeTarget(targetEl);
    });
  }

  function initializeExistingTargets() {
    document.querySelectorAll(TRIGGER_SELECTOR).forEach(function (triggerEl) {
      var targetRaw = (triggerEl.getAttribute('data-form-target') || '').trim();
      if (!targetRaw) return;
      var targetEl = resolveTarget(targetRaw);
      if (!targetEl) return;
      setupTarget(targetEl);
    });
  }

  function run() {
    if (!hasPageMarker()) return;
    initializeExistingTargets();
    document.addEventListener('click', onDocumentClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();


